import { Col, SelectField } from '@/components';
import {
  AdministrativeReformTeamEvaluationOptionLabelModifier,
  administrativeReformTeamEvaluationOptions,
} from '@/features/project/_models/project-filter';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const SkipAdministrativeReformTeamEvaluationColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const fiscalYear = useWatch({
    control,
    name: 'fiscalYear',
  });

  if (isPS() || sheetType !== 'RS') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="skipAdministrativeReformTeamEvaluation"
        label={t('filter-by-skip-administrative-reform-team-evaluation')}
        control={control}
        errors={errors}
        options={administrativeReformTeamEvaluationOptions.options.map(
          (value) => ({
            value,
            label: AdministrativeReformTeamEvaluationOptionLabelModifier[value],
            disabled: value === 'true' && !fiscalYear,
          }),
        )}
        allowClear={!!fiscalYear}
      />
    </Col>
  );
});
